import { render } from "./FertilizerForm.vue?vue&type=template&id=42ed6530&ts=true"
import script from "./FertilizerForm.vue?vue&type=script&lang=ts"
export * from "./FertilizerForm.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__